import { Route, Switch } from 'react-router-dom';
import AllPlayersContainer from './all-players-container';

function Squad() {
  return (
    <Switch>
      <Route exact path="/all-players" component={AllPlayersContainer} />
      <Route exact path="/all-players/:season" component={AllPlayersContainer} />
    </Switch>
  );
}

export default Squad;
